// First-touch + last-touch attribution capture (stored in localStorage).
const KEY = "recoveros_attribution";

function sessionId() {
  try {
    let s = sessionStorage.getItem("recoveros_session_id");
    if (!s) { s = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("recoveros_session_id", s); }
    return s;
  } catch (e) { return ""; }
}

// Call once on app load. Captures first-touch UTM/referrer/landing and refreshes last_visit.
export function initAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const now = new Date().toISOString();
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    const utm = {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
    };
    const hasUtm = Object.values(utm).some(Boolean);
    if (!existing) {
      const data = {
        ...utm,
        referrer: document.referrer || "",
        landing_page: window.location.href,
        first_landing_page: window.location.href,
        first_visit: now,
        last_visit: now,
        session_id: sessionId(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      };
      localStorage.setItem(KEY, JSON.stringify(data));
    } else {
      existing.last_visit = now;
      existing.landing_page = window.location.href;
      existing.session_id = sessionId();
      // A fresh campaign visit overwrites the (weaker) touch data.
      if (hasUtm) Object.assign(existing, utm, { referrer: document.referrer || existing.referrer });
      localStorage.setItem(KEY, JSON.stringify(existing));
    }
  } catch (e) { /* noop */ }
}

export function getAttribution() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "null") || {};
    d.last_visit = new Date().toISOString();
    d.session_id = d.session_id || sessionId();
    d.timezone = d.timezone || (Intl.DateTimeFormat().resolvedOptions().timeZone || "");
    return d;
  } catch (e) { return {}; }
}
